module.exports = __webpack_public_path__ + "img/act_icon_06.fa343dc.png";